import React, { useMemo } from 'react';
import { useResponsive } from '@common-fe/common-fe';
import { Grommet as CommonGrommet } from '@common-fe/common-fe';
import { Grommet } from 'grommet';
import _ from 'lodash';
import { css } from 'styled-components';

import { useCombinedTheme } from '@/modules/core/hooks/useCombinedTheme';
import themeColors from '@/styles/colors';

interface Props {
  children: React.ReactNode;
}
export const MOBILE_FILED_HEIGHT = '48px';
const MobileResponsiveWrapper: React.FC<Props> = ({ children }) => {
  const { isMobile } = useResponsive();
  const combinedTheme = useCombinedTheme();

  const theme = useMemo(() => {
    if (!isMobile) return combinedTheme;

    return _.merge(_.cloneDeep(combinedTheme), {
      controls: {
        height: MOBILE_FILED_HEIGHT,
        buttons: {
          height: {
            height: MOBILE_FILED_HEIGHT,
          },
        },
      },
      input: {
        common: {
          'min-height': MOBILE_FILED_HEIGHT,
        },
      },
      height: {
        input: { height: MOBILE_FILED_HEIGHT },
      },
      formFieldsEdging: {
        padding: '12px',
        outline: '8px solid #F7F9FA',
        borderRadius: '12px',
        margin: '0px',
      },
      global: {
        edgeSize: {
          ...{
            moduleRound: combinedTheme.rounds.moduleRound !== '0px' ? '12px' : undefined,
          },
        },
        size: {
          medium: '100%',
        },
      },
      rounds: {
        ...{
          moduleRound: combinedTheme.rounds.moduleRound !== '0px' ? '12px' : undefined,
        },
      },
      pagination: {
        button: {
          color: 'textBody',
        },
      },
      select: {
        // background: 'red',
        container: {
          extend: css`
            background-color: ${themeColors.canvas} !important;
          `,
        },
      },
    });
  }, [combinedTheme, isMobile]);

  return (
    <CommonGrommet theme={theme}>
      <Grommet theme={theme}>
        {children}
      </Grommet>
    </CommonGrommet>
  );
};

export default MobileResponsiveWrapper;
